import React, { useState } from 'react';
import { Plate, SubHeader } from 'features/shared/ui/Page';
import Spacer from 'features/shared/Spacer';
import People, { PeopleType } from './people';
import SwitchTabs, { BluePillsTab, SwitchTabsType } from 'features/shared/SwitchTabs';
import Classes from './classes';
import { MunicipalitySelector, SchoolSelector } from './ChartDataSelector';
import useUserData from 'hooks/useUserData';
import { useClickStreamContext } from 'features/shared/ClickStream';

interface Props {
  isRegion: boolean;
}

enum TabId {
  Students = 'Ученики',
  Teachers = 'Учителя',
  Classes = 'Классы',
}

const tabs = [
  { id: TabId.Students, label: 'Ученики' },
  { id: TabId.Teachers, label: 'Учителя' },
  { id: TabId.Classes, label: 'Классы' },
];

const Component = ({ isRegion }: Props) => {
  const { logPageEvent } = useClickStreamContext();

  const [tab, setTab] = useState(tabs[0]);
  const [filter, setFilter] = useState<{ value: number; label: string } | null>(null);

  const { regionName, department } = useUserData() || {};

  return (
    <Plate data-qa-id="statistics_schools">
      <SubHeader>{isRegion ? 'Статистика по региону и муниципалитетам' : 'Статистика по муниципалитету'}</SubHeader>
      <Spacer size={40} />
      <SwitchTabs
        values={tabs}
        value={tab}
        tabRenderer={(props) => <BluePillsTab {...props} style={{ minWidth: 182 }} />}
        handleChange={(value) => {
          setTab(value);
          logPageEvent({
            eventType: 'schools_statistic_by_month_tab' + value.id,
            eventInfo: 'Школы|Статистика по месяцам: Перешел на вкладку ' + value.label,
          });
        }}
        type={SwitchTabsType.pills}
        qaPrefix="statistics_schools_"
      />
      <Spacer size={40} />
      {isRegion ? (
        <MunicipalitySelector
          value={filter}
          setValue={(value) => {
            setFilter(value);
            if (filter) {
              logPageEvent({
                eventType: 'schools_statistic_by_month_change_municipality_filter',
                eventInfo: 'Школы|Статистика по месяцам: выбрал значение в фильтре по муниципалитету',
              });
            }
          }}
          regionName={regionName}
        />
      ) : (
        <SchoolSelector
          value={filter}
          setValue={(value) => {
            setFilter(value);
            if (filter) {
              logPageEvent({
                eventType: 'schools_statistic_by_month_change_school_filter',
                eventInfo: 'Школы|Статистика по месяцам: выбрал значение в фильтре по школам',
              });
            }
          }}
          municipalityName={department}
        />
      )}
      <Spacer size={40} />
      {(tab.id === TabId.Students || tab.id === TabId.Teachers) && (
        <People
          type={tab.id === TabId.Students ? PeopleType.Students : PeopleType.Teachers}
          filter={filter?.value || null}
          isRegion={isRegion}
        />
      )}
      {tab.id === TabId.Classes && <Classes filter={filter?.value || null} isRegion={isRegion} />}
    </Plate>
  );
};

export default Component;
